export default "__VITE_ASSET__67561003__"